import ClipLogoUrl from '@assets/images/partners/clip.png';
import LoyverseLogoUrl from '@assets/images/partners/loyverse.png';
import MercadoPagoLogoUrl from '@assets/images/partners/mercadoPago.png';
import PickerLogoUrl from '@assets/images/partners/picker.png';
import StripePagoLogoUrl from '@assets/images/partners/stripe.png';
import { IntegrationCard, IntegrationDetail, IntegrationSection } from '@interfaces/Integration';
import { IntegrationConfiguration, ModuleName } from '@utils/constants';
// import { hasFeatureFlag } from '@utils/hooks/useGetFeatureFlags';
import { IconBrandWhatsappFilled } from '@tabler/icons-react';
import { WhatsappQrModal } from './components/providers/whatsapp/WhatsappQrModal';
import { useWhatsappConnection } from './components/providers/whatsapp/hooks/useWhatsappConnection';

// ... (existing code)

// const jelpIntegration: IntegrationCard = {
//   provider_code: 'jelp',
//   provider_type: 'delivery',
//   logo_url: JelpLogoUrl,
//   available: true,
//   description: 'Automatiza las operaciones de entrega de tus pedidos recibidos en Plick.',
//   website: 'https://jelp.app/',
//   help_link: 'https://wa.me/5216647773919',
//   disclaimer:
//     'Para activar este servicio debes tener activo Envío a domicilio. Ingresa los siguientes datos de tu API Key de tu cuenta [Jelp Delivery](https://jelp.app/).',
//   notes: [
//     '* Pagos de tarifas y comisiones de este servicio se realizan directamente con la empresa Jelp Delivery',
//     '* Al activar este servicio estas de acuerdo en que una empresa ajena a Plick realice las entregas, por lo que **Plick no se hace responsable de cualquier evento o incidencia ocurrida en la entrega**.',
//   ],
//   configuration: {
//     branch_code: { key: 'branch_code', label: 'Código de sucursal', default: '' },
//     sign: { key: 'sign', label: 'Sign', default: '' },
//     api_key: { key: 'api_key', label: 'Api key', default: '' },
//   },
//   actions: ['connect', 'disconnect', 'detail', 'configuration'],
// };

const pickerIntegration: IntegrationCard = {
  provider_code: 'picker',
  provider_type: 'delivery',
  logo_url: PickerLogoUrl,
  available: true,
  description: 'Automatiza las operaciones de entrega de tus pedidos recibidos en Plick.',
  website: 'https://dashboard.pickerexpress.com/',
  disclaimer:
    'Para activar este servicio debes tener activo Envío a domicilio. Ingresa los siguientes datos de tu API Key de tu cuenta [Picker Express](https://dashboard.pickerexpress.com/settings/general).',
  notes: [
    '* Pagos de tarifas y comisiones de este servicio se realizan directamente con la empresa Picker Express',
    '* Al activar este servicio estas de acuerdo en que una empresa ajena a Plick realice las entregas, por lo que **Plick no se hace responsable de cualquier evento o incidencia ocurrida en la entrega**.',
  ],
  configuration: {
    token: { key: 'token', label: 'Token', default: '', fieldType: 'private' },
  },
  actions: ['connect', 'disconnect', 'sync', 'go_to_provider_dashboard'],
};

const loyverseIntegration: IntegrationCard = {
  provider_code: 'loyverse',
  provider_type: 'tpv',
  logo_url: LoyverseLogoUrl,
  available: true,
  description: 'Conecta y sincroniza tu menú Plick con el punto de venta y gestión de inventario.',
  website: 'https://loyverse.com/',
  disclaimer: 'Ingresa los siguientes datos para conectar tu cuenta de Loyverse con tu menú digital Plick.',
  notes: [
    '* Al dar clic en Guardar tu menú actual se eliminará y se copiará el que tengas creado en tu cuenta de Loyverse.',
    '* El menú solo podrá ser administrado desde tu cuenta Loyverse.',
    '* Podrás sincronizarlos cada que lo desees.',
  ],
  configuration: {
    store_id: { key: 'store_id', label: 'ID de sucursal', default: '' },
    token: { key: 'token', label: 'Token', default: '' },
  },
  actions: ['connect', 'disconnect', 'configuration'],
};

// const softRestaurantIntegration: IntegrationCard = {
//   provider_code: 'softRestaurant',
//   provider_type: 'rms',
//   logo_url: SoftRestauranteLogoUrl,
//   available: true,
//   description: 'Integra tu menú Plick con Soft Restaurant para la gestión de tu restaurante.',
//   website: 'https://softrestaurant.com/',
//   disclaimer: 'Ingresa los siguientes datos para conectar tu cuenta de Softrestaurant con tu menú digital Plick.',
//   notes: [
//     '* Al dar clic en Guardar tu menú actual se eliminará y se copiará el que tengas creado en tu cuenta de Loyverse.',
//     '* El menú solo podrá ser administrado desde tu cuenta Loyverse.',
//     '* Podrás sincronizarlos cada que lo desees.',
//   ],
//   configuration: {
//     api_key: { key: 'api_key', label: 'Api key', default: '' },
//   },
//   actions: ['connect', 'disconnect', 'sync'],
// };

const stripeIntegration: IntegrationCard = {
  provider_code: 'stripe',
  provider_type: 'payment',
  logo_url: StripePagoLogoUrl,
  helpVideoUrl: 'https://youtu.be/7J8Z8r6VQSw',
  helpVideoTitle: 'Tutorial: Stripe',
  helpVideoDescription: 'Aprende cómo conectar tu cuenta de Stripe con tu menú digital Plick.',
  available: true,
  description: 'Agiliza los pagos en tu menú Plick con Stripe: seguridad y eficiencia en cada transacción..',
  website: 'https://stripe.com/en-mx',
  disclaimer:
    'Ingresa los siguientes datos para conectar tu cuenta de Stripe con tu menú digital Plick. Los puedes conseguir [haciendo click aquí](https://dashboard.stripe.com/account/apikeys).',
  configuration: {
    public_key: { key: 'public_key', label: 'Clave publicable', default: '', fieldType: 'public' },
    secret_key: { key: 'secret_key', label: 'Clave secreta', default: '', fieldType: 'private' },
  },
  actions: ['connect', 'disconnect'],
};

const clipIntegration: IntegrationCard = {
  provider_code: 'clip',
  provider_type: 'payment',
  logo_url: ClipLogoUrl,
  available: true,
  description: 'Integra Clip a tu sistema para ofrecer una solución de pago ágil y segura.',
  website: 'https://www.clip.mx/',
  disclaimer:
    'Ingresa los siguientes datos para conectar tu cuenta de Clip con tu menú digital Plick. Los puedes conseguir [haciendo click aquí](https://dashboard.developer.clip.mx/applications).',
  configuration: {
    public_key: { key: 'public_key', label: 'API Key', default: '', fieldType: 'public' },
    secret_key: { key: 'secret_key', label: 'Clave secreta', default: '', fieldType: 'private' },
  },
  actions: ['connect', 'disconnect'],
};

const mercadoPagoIntegration: IntegrationCard = {
  provider_code: 'mercadoPago',
  provider_type: 'payment',
  logo_url: MercadoPagoLogoUrl,
  helpVideoUrl: 'https://youtu.be/jc2CK5Z6XoA',
  helpVideoTitle: 'Tutorial: Mercado Pago',
  helpVideoDescription: 'Aprende cómo conectar tu cuenta de Mercado Pago con tu menú digital Plick.',
  available: true,
  description: 'Conecta tu menú Plick con Mercado Pago y transforma la manera en que procesas los pagos.',
  website: 'https://www.mercadopago.com.mx/',
  configuration: {
    public_key: { key: 'public_key', label: 'Public key', default: '', fieldType: 'public' },
    secret_key: { key: 'secret_key', label: 'Access token', default: '', fieldType: 'private' },
  },
  actions: ['connect', 'disconnect'],
};

// const netPayIntegration: IntegrationCard = {
//   provider_code: 'netpay',
//   provider_type: 'payment',
//   logo_url: NetPayLogoUrl,
//   available: hasFeatureFlag('netpay-register'),
//   description: 'Integra tu menú Plick con NetPay para un procesamiento de pagos en línea rápido y seguro.',
//   website: 'https://netpay.mx/',
//   configuration: {
//     api_key: { key: 'api_key', label: 'Api key', default: '' },
//   },
//   actions: ['connect', 'disconnect', 'sync'],
// };

const whatsappBusinessIntegration: IntegrationCard = {
  provider_code: 'whatsappBusiness',
  provider_type: 'communication',
  logo_url: IconBrandWhatsappFilled,
  helpVideoUrl: 'https://youtu.be/1wtjblaFd3A',
  helpVideoTitle: 'Tutorial: WhatsApp Business',
  helpVideoDescription: 'Aprende cómo conectar tu cuenta de WhatsApp Business con tu menú digital Plick.',
  available: true,
  description:
    'Automatiza la comunicación con tus clientes. Mantén informados a tus clientes con el estatus de su pedido en tiempo real.',
  website: 'https://www.whatsapp.com/',
  configuration: {}, // Self-service: conexión vía QR, no requiere configuración manual
  logoClassName: 'bg-color-whatsapp_dark text-color-white',

  // Custom upsell modal
  upsellTitle: 'Integración con WhatsApp Business',
  upsellDescription:
    'La integración envía automáticamente un mensaje personalizado cada vez que cambia el estatus de un pedido.\n\nAdapta cada mensaje al tono de voz de tu marca, agrega links a tus redes sociales, incluye cupones para la próxima compra o incluso una encuesta rápida para conocer la experiencia de tus clientes.\n\n**Métodos de entrega soportados:**\nEnvío a domicilio, Pasar a Recoger y Comer en Restaurante.',
  upsellCtaLabel: 'Más Información',
  upsellCtaUrl:
    'https://api.whatsapp.com/send?phone=+529935318237&text=Me%20interesa%20la%20Integraci%C3%B3n%20de%20WhatsApp%20Business.',

  // Nuevas acciones basadas en composition pattern
  actions: ['qr_connect', 'show_status', 'configuration'],

  // Tipo de conexión
  connectionType: 'qr',

  // Hook personalizado para conexión
  useConnectionHook: useWhatsappConnection,

  // Modal de conexión QR
  ConnectionModal: WhatsappQrModal,
};

export const integrationSections: IntegrationSection[] = [
  {
    title: 'Notificaciones a clientes',
    integrations: [whatsappBusinessIntegration],
    moduleName: ModuleName.NOTIFICACIONES_CLIENTE_WHATSAPP,
  },
  {
    title: 'Servicios de repartidores',
    integrations: [pickerIntegration], // Jelp temporalmente oculto
    moduleName: ModuleName.PROVEEDORES_ENTREGA,
  },
  {
    title: 'Puntos de venta',
    integrations: [loyverseIntegration],
    moduleName: ModuleName.LOYVERSE, // Cambio específico para Loyverse
  },
  {
    title: 'Gestion de restaurante',
    integrations: [
      /*softRestaurantIntegration*/
    ], // SoftRestaurant temporalmente oculto
  },
  {
    title: 'Metodos de pago',
    integrations: [stripeIntegration, clipIntegration, mercadoPagoIntegration], // NetPay temporalmente oculto
  },
];

export const commerceIntegrations: IntegrationCard[] = integrationSections.flatMap((section) => section.integrations);

export const defaultIntegrationConfig: IntegrationConfiguration = {
  token: '',
  sign: '',
  branch_code: '',
  api_key: '',
};

const jelpDataBalanceCode = 'usableBalance';
export const jelpIntegrationDetail: IntegrationDetail = {
  provider_code: 'jelp',
  provider_type: 'delivery',
  availableData: [],
  cardAvailableData: [
    {
      code: jelpDataBalanceCode,
      label: 'Saldo Disponible',
      icon: 'ion:wallet',
    },
  ],
  configuration: {
    fields: [],
  },
};

export const commerceIntegrationDetails: IntegrationDetail[] = [jelpIntegrationDetail];
export const integrationDetailsMap = commerceIntegrationDetails.reduce(
  (map, detail) => {
    map[detail.provider_code] = detail;
    return map;
  },
  {} as { [key: string]: IntegrationDetail },
);

export interface IntegrationError {
  errorCode: string;
  message: string;
  requestId: string;
}

export interface ProviderData {
  [key: string]: string | number | boolean | object;
}

export interface ProviderConfigurationPayload<T> {
  providerData: T;
}

export type MissingValuesChecker<T> = (registerData: T) => (keyof T)[];
